var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('component',_vm._b({staticClass:"profileReport",model:{value:(_vm.reload),callback:function ($$v) {_vm.reload=$$v},expression:"reload"}},'component',_vm.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }